import cn from 'classnames';

export interface KeyValueItem {
  key: string;
  value: React.ReactNode;
}

export interface KeyValueStripeTableProps {
  items: KeyValueItem[];
  className?: string;
  activeRowIndex?: number;
  equalColumns?: boolean;
  valueAlign?: 'left' | 'right';
  bordered?: boolean;
  firstWhite?: boolean;
}

export const KeyValueStripeTable = ({
  items,
  className,
  activeRowIndex,
  equalColumns,
  valueAlign = 'left',
  bordered = true,
  firstWhite = false
}: KeyValueStripeTableProps) => (
  <table className={cn('table mb-0', bordered && 'table-row-bordered', className)}>
    <tbody>
      {items.map((item, rowIndex) => {
        const isActive = activeRowIndex !== undefined && rowIndex === activeRowIndex;
        const isLightRow = firstWhite ? rowIndex % 2 === 1 : rowIndex % 2 === 0;
        const rowClass = cn(isLightRow && 'bg-light', isActive && 'bg-secondary bg-opacity-10');
        return (
          <tr key={rowIndex} className={rowClass}>
            <td className={cn('fw-semibold fs-7 text-gray-500 py-2 px-3', equalColumns ? 'w-50' : 'w-150px')}>
              {item.key}
            </td>
            <td
              className={cn(
                'fw-semibold fs-7 text-gray-800 py-2 px-3',
                equalColumns && 'w-50',
                valueAlign === 'right' && 'text-end'
              )}
            >
              {item.value}
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
);
